import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=21606031&scoped=true"
import script from "./PhoneInput.vue?vue&type=script&lang=js"
export * from "./PhoneInput.vue?vue&type=script&lang=js"
import style0 from "./PhoneInput.vue?vue&type=style&index=0&id=21606031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../2026-08-26/github-cli-gh-codex/work/jiangkv3/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21606031",
  null
  
)

export default component.exports